<template>
  <div data-hover data-delay="0" class="side-nav w-dropdown">
    <div @click="mobileOpen=!mobileOpen" class="dropdown-toggle-side w-dropdown-toggle">
      <p class="path-name">{{selectedPath.title}}</p>
      <p class="path-det">{{selectedPath.sponser}}</p>
      <div class="side-icon w-icon-dropdown-toggle"></div>
    </div>
    <div class="dropdown-wrapper w-dropdown-list" :class="{'w--open':mobileOpen}">
      <div v-for="(chapter,i) in pathChapters" :key="chapter._id">
        <ExpansionWidget :chapter-index="i" :chapter="chapter" />
      </div>
    </div>
  </div>
</template>
<script>
import ExpansionWidget from "../components/ExpansionWidget";
import {mapGetters} from 'vuex';

export default {
  name: "Sidebar",
  data(){
    return {
      mobileOpen:false,
      pathChapters: []
    }
  },
  components: { ExpansionWidget },
  computed: {
    selectedPath() {
      return this.getSelectedPath;
    },
    ...mapGetters(['getSelectedPath'])
  },
  watch:{
    async getSelectedPath(){
      this.pathChapters = await this.$store.dispatch('fetchChaptersOfPath');
    }
  }
};
</script>
<style>
@media screen and (min-width: 768px) {
  .side-nav {
    height: calc(100vh - 64px);
  }

  .dropdown-wrapper {
    height: calc(100vh - 200px);
  }
}
</style>